import { Constants } from '../../util/constants';
import { LanguageModel } from './language.model';

export const languagesConst: Array<LanguageModel> = [
    {
        icon: 'fi-gb',
        text: 'navbar.language.en',
        localeId: Constants.LOCALE_EN
    },
    {
        icon: 'fi-ro',
        text: 'navbar.language.ro',
        localeId: Constants.LOCALE_RO
    }
];
